import React, { useEffect, useState } from 'react'
import Footer from "../components/Footer"
import Header from "../components/Header"
import { JourneyProvider } from "../components/context/journeyContext"
import Loader1 from '../interceptors/loader-interceptor'
import { getIpAddress, getJWTTokenForIp, getSalesPerson } from '../services/apiservice'
import base64 from 'base-64'
import { withPrefix } from 'gatsby'
import * as channelJson from "../../static/channel.json"
import { getBranchRm } from '../services/rm-led-service'
import Select from "react-select"
import styled from "styled-components"
var CryptoJS = require("crypto-js");

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;

    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 0.6rem 0;
      padding-bottom: 0;
    }
    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;        
        padding-right: 4px !important;        
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;
    }
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background:var(--lumiq-bg)
    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`



function BQP(props) {
    const [channel, setChannel] = useState([])
    const [allBQP, setAllBQP] = useState([])
    const [isBQPvisible, setIsBQPvisible] = useState(false)
    const [localValues, setLocalValues] = useState({
        channelName: "",
        BQP: "",
    })
    const [showError, setShowError] = useState(false)

    // apply styles of channel other than canara and hsbc (that is others/website) 
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const source = urlParams.get("source")
        let channelValue;

        // 'source' is only used for internal logic and never for URL redirection.
        // Allowed values are strictly validated to prevent misuse or injection.
        if (source && ["MIBL","MAIBRO"].includes(source?.toUpperCase())) {
            channelValue = source?.toUpperCase();
            setChannel([{ key: channelValue, value: channelValue }])
            setLocalValues(prev => ({
                ...prev,
                channelName: channelValue
            }))
        } else {
            channelValue = props?.resumeJourneyData?.sourceFromResumeJourney?.toUpperCase() || "MIBL";
            setChannel([{ key: channelValue, value: channelValue }])
            setLocalValues(prev => ({
                ...prev,
                channelName: channelValue
            }))
        }

        setIsBQPvisible(true)
        const otherChannel = channelJson.data.channels.find(channel => channel.channelId === "others")
        const otherChannelCssRules = otherChannel.csskeyvalue
        otherChannelCssRules.forEach(cssRule => {
            document.documentElement.style.setProperty(cssRule.cssKey, cssRule.cssValue);
        })
        document.documentElement.style.setProperty("--lumiq-img-url", `url(${withPrefix('/images/icon-others.png')})`);
        document.documentElement.style.setProperty("--lumiq-checkbox", `url(${withPrefix('/images/chek-box-others.png')})`);

        // Call handleChange with the selected channel to trigger the fetch
        setTimeout(() => {
            handleChange({key: channelValue ,label:channelValue} , "channel");
        }, 0);
    }, [])

    const fetch = async () => {
        try {
            const res = await getSalesPerson("HSBC");
            const data = res.data?.data;
            setAllBQP([...data])
            // setIsBQPvisible(true)
        } catch (error) {
            console.log(error)
        }
    }

    const handleChange = async ( target , value) => {
        if (value === "channel") {
            setLocalValues(prev => {
                return {
                    ...prev,
                    channelName: target,
                }
            })
            setAllBQP([])
            fetch()
        } else if (value === "BQP") {
            setLocalValues(prev => {
                return {
                    ...prev,
                    BQP: target
                }
            })
        }
    }

    const handleSubmit = e => {
        e.preventDefault()
        if (!localValues.channelName || !localValues.BQP) {
            setShowError(true)
        } else {
            let BQPName = allBQP.find(e => e.value === localValues.BQP.key)
            let channelName = channel?.find(e => e.value === localValues.channelName.key)
            let BQPData = { channelName: channelName.value, BQPName: BQPName.value, resumeJourneyData: props?.resumeJourneyData || null, shouldSaveAgentDetails: props?.resumeJourneyData || false }
            setShowError(false)
            props.isJourneyStartBQP(BQPData)
        }
    }
    return (
        <>
            <JourneyProvider>
                {/* <Header /> */}
                <Loader1 />
                <div className="landing-page1-design">
                    <style>
                        {
                            `
       
        `
                        }
                    </style>
                    {isBQPvisible ? (
                        <div className="Q4-option2-design-structure" style={{ backgroundColor: "transparent" }} >
                            <div className="container">
                                <div className="iselect-box-design">
                                    <div className="heading-design">
                                        <div className="iselect-padding left-side-head">
                                            <h1 className="iselect-heading">
                                                PLEASE SELECT BROKER QUALIFIED PERSON TO CONTINUE
                                            </h1>
                                        </div>
                                    </div>

                                    <form>

                                        <div className="iselect-padding if-yes" id="div3" style={{ marginLeft: "14px" }}>
                                            <div className="iselect-mg-bottom mt-20 row">
                                                <div className="col-md-6 col-xs-12 all-box-padding-right mt-auto mb-auto">
                                                    <div className="form-group ">
                                                        {/* <label className="title-bg input-label" > Channel </label>
                                                        <select
                                                            className="select2 form-control"
                                                            name="a1"
                                                            value={localValues.channelName}
                                                            onChange={e => handleChange(e, "channel")}
                                                        >
                                                            <option value="">Select</option>
                                                            {channel?.map(
                                                                (ele, index) =>
                                                                    ele.key &&
                                                                    typeof ele.key === "string" &&
                                                                    ele.value &&
                                                                    typeof ele.value === "string" && (
                                                                        <option
                                                                            key={ele.key}
                                                                            value={ele.key}
                                                                        >
                                                                            {ele.value}
                                                                        </option>
                                                                    )
                                                            )}
                                                        </select> */}
                                                         <SelectContainer channel={props.channel} className={`input-container`}>
                                                            <label htmlFor={"Channel"} className="input-label">
                                                                Channel
                                                            </label>
                                                            <Select
                                                                options={channel.map(e => { return { key: e.key, label: e.value } })}
                                                                name={"Channel"}
                                                                value={localValues.channelName}
                                                                onChange={e => handleChange(e, "channel")}
                                                                style={{marginTop:"auto"}}


                                                            />
                                                        </SelectContainer>
                                                    </div>
                                                    {showError && localValues.channelName === "" && (
                                                        <div>
                                                            <label id="a1-error" className="error" for="a1">
                                                                Please select Branch Name
                                                            </label>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col-md-6 col-xs-12 all-box-padding-left align-items-end">
                                                    <div className="form-group input-group">
                                                        {/* <label className="title-bg inp-label">
                                                            Broker Qualified Person
                                                        </label>
                                                        <select
                                                            className="select2 form-control"
                                                            name="a2"
                                                            value={localValues.BQP}
                                                            onChange={e => handleChange(e, "BQP")}
                                                        >
                                                            <option value="">Select</option>
                                                            {allBQP.map(
                                                                (ele, index) =>
                                                                    ele.key &&
                                                                    typeof ele.key === "string" &&
                                                                    ele.value &&
                                                                    typeof ele.value === "string" && (
                                                                        <option
                                                                            key={ele.key}
                                                                            value={ele.key}
                                                                        >
                                                                            {ele.value}
                                                                        </option>
                                                                    )
                                                            )}
                                                        </select> */}
                                                        <SelectContainer channel={props.channel} className={`input-container`}>
                                                            <label htmlFor={"Broker Qualified Person"} className="input-label">
                                                                Broker Qualified Person
                                                            </label>
                                                            <Select
                                                                options={allBQP.map(e => { return { key: e.key, label: e.value } })}
                                                                name={"Broker Qualified Person"}
                                                                value={localValues.BQP}
                                                                onChange={e => handleChange(e, "BQP")}
                                                                style={{marginTop:"auto"}}


                                                            />
                                                        </SelectContainer>
                                                    </div>
                                                    {showError && localValues.relationshipManager === "" && (
                                                        <div>
                                                            <label id="a2-error" className="error" for="a2">
                                                                Please select Relationship Manager
                                                            </label>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="iselect-mg-bottom pd40 ">
                                            <div className="col-md-12">
                                                <div className="but-center text-right">

                                                    <input
                                                        className="previous-btn cen"
                                                        aria-hidden="true"
                                                        style={{
                                                            color: "white",
                                                            padding: "14px 50px",
                                                            border: "none",
                                                        }}
                                                        type="submit"
                                                        value="Submit"
                                                        onClick={handleSubmit}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div></div>
                    )}
                    {/* <Footer /> */}
                </div>
            </JourneyProvider>
        </>

    )
}

export default BQP